import React, { useEffect, useState } from "react";
import { getEventCodes, generateEventCode, deleteEventCode, updateEventCodeNote } from "../../Services/EventCodes";
import EventCodesTable from "./Components/EventCodesTable";
import DeleteCodeModal from "./Components/DeleteCodeModal";
import Loader from "../../Layouts/Loader";

const Codes = () => {
  const [codes, setCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [error, setError] = useState(null);

  const fetchCodes = () => {
    setLoading(true);
    getEventCodes()
      .then((res) => {
        setCodes(res.data.data.responseData);
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to load event codes");
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchCodes();
  }, []);

  const handleGenerateCode = () => {
    setLoading(true);
    generateEventCode()
      .then((res) => {
        fetchCodes();
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to generate event code");
        setLoading(false);
      });
  };

  const handleDeleteCode = (code) => {
    setLoading(true);
    deleteEventCode(code)
      .then(() => {
        fetchCodes();
        setShowDeleteModal(false);
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to delete event code");
        setLoading(false);
      });
  };

  const handleUpdateNote = (code, note) => {
    return updateEventCodeNote(code, note)
      .then(() => {
        fetchCodes();
        setError(null);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to update event code note");
        throw err;
      });
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div className="page_header">
          <h2 className="mb-0">Event Codes</h2>
        </div>
        <div>
          <button
            className="btn btn-danger me-2"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete Code
          </button>
          <button
            className="btn btn-primary"
            onClick={handleGenerateCode}
            disabled={loading}
          >
            Generate New Code
          </button>
        </div>
      </div>

      {error && (
        <div className="alert alert-danger" role="alert">
          {error}
        </div>
      )}

      <div className="card">
        <div className="card-body">
          {loading ? (
            <Loader />
          ) : codes.length > 0 ? (
            <EventCodesTable
              codes={codes}
              onDeleteCode={handleDeleteCode}
              onUpdateNote={handleUpdateNote}
            />
          ) : (
            <h5 className="text-center p-3">No event codes available</h5>
          )}
        </div>
      </div>

      <DeleteCodeModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        onDelete={handleDeleteCode}
      />
    </>
  );
};

export default Codes; 